<div class="glass-house-quantity-and-price">
  <div
    *rxFor="let col of cappedSpoofedGridColViewModels; strategy: 'immediate'"
    class="glass-house-2-columns glass-house-line-item">
    <div class="glass-house-quantity-and-badges">
      <div class="glass-house-quantity">
        {{ parentViewModel | getExpandedGridSize: col : true : false : false : false | push: 'immediate' }}
      </div>
      @let productTags = data | method: 'getProductTagsFor' : col?.variant;
      <div *rxIf="productTags?.length > 0; strategy: 'immediate'" class="glass-house-product-tags">
        <div *rxFor="let productTag of productTags; strategy: 'immediate'" class="glass-house-product-tag">
          {{ productTag?.name }}
        </div>
      </div>
    </div>
    <div class="glass-house-price">
      <app-glass-brands-house-price [parentViewModel]="parentViewModel" [columnViewModel]="col" />
    </div>
  </div>
  <div class="glass-house-2-columns">
    <div *rxIf="plusNMoreCols > 0; strategy: 'immediate'" class="glass-house-n-more">+ {{ plusNMoreCols }} More</div>
    <div></div>
  </div>
</div>
